export default __webpack_public_path__ + "static/media/device-bad.af1630ae.svg";